import React, { useState, useEffect } from 'react';
import { Input } from 'antd';
interface props {
  value?: any
  onChange?: any
  disabled?: any
}

const SPFormatCash: React.FC<props> = (props) => {
  const { value, onChange, disabled = false } = props

    return (
      < >
        {value !== undefined && <Input addonAfter="元" disabled={disabled} value={value == undefined ? '' : value / 100} onChange={(value: any) => onChange(value * 100)}></Input>}
      </>
    )
}

export default SPFormatCash